export default {
  state: {
    categoryData: {},
  },

  getters: {
    getCategoryData(state) {
      return state.categoryData;
    },
  },

  mutations: {
    setCategoryData(state, data) {
      const isNull = data === null;

      state.categoryData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
      };
    },
  },

  actions: {
    changeCategoryData(context, infos) {
      context.commit("setCategoryData", infos);
    },
  },
};
